<template lang="pug">
#wrap_sub
  .sub_right
    .content_desc
      .container_skip
      #s51.sub
        .in
          .tit
            h2.s_tit
              span Find INTHEKEG
          .bo_list
            .map_bg
              #canvas
                south-svg(@select-area='clickedArea' ref="south")
              .map_btn
                .top
                  span
                    img(:src='require("../../assets/images/map_logo.png")' alt='')
                  span
                .bot
                  ul
                    li
                      h4
                        a(:id='[selectArea == 0 ? "bo_cate_on" : ""]' @click='clickedCat(0)') All
                    li(v-for="item in areaCategory" :key="item.id")
                      h4
                        a(@click='clickedCat(item.id)' :id='[selectArea == item.id ? "bo_cate_on" : ""]') {{item.name}}
            #fboardlist
              ul.board_newlist
                li.board_list_tit
                  .name Store name
                  .info.mo Store info
                  .address Address
                  .call Tel
                  .map Map
                li.board_list_con(v-for="(item, index) in storeList" :key="item.IDX")
                  .info.mo(v-if="isMobile")
                    .name
                      a(@click='$_goTo({name: "detail-store", params: {id: item.IDX}})') {{item.SHOP_NAME}}
                    .address {{item.SHOP_DETAIL_ADDR ? item.SHOP_DETAIL_ADDR + ', ' : ''}} {{item.SHOP_ADDR}}
                  .name(v-if="!isMobile")
                    a(@click='$_goTo({name: "detail-store", params: {id: item.IDX}})') {{item.SHOP_NAME}}
                  .address
                    span {{item.SHOP_DETAIL_ADDR ? item.SHOP_DETAIL_ADDR + ', ' : ''}} {{item.SHOP_ADDR}}
                  .call
                    span {{item.SHOP_MOBILE}}
                  .map
                    span
                      a.open-popup-link(@click='openModal(index)' alt='')
                        img(:src='require("../../assets/images/map_icon.png")' alt='')
                li.nopost(v-if="storeList.length == 0") There is no INTHEKEG store.
          nav.pg_wrap
            span.pg(v-if="storeList.length !== 0")
              a.pg_page.pg_start(@click='selectPage("prev")' v-if="paging[2]")
              a.pg_page(v-for="(num, id) in pageNumber" :key="id" @click='selectPage(num)' :class='[page == num ? "pg_current" : ""]') {{num}}
              a.pg_page.pg_end(@click='selectPage("next")' v-if="paging[3]")
  .modal(v-if="showModal")
    .modal_mask(@click='closeModal()')
    .modal_card
      .modal-btn
        button(@click='closeModal()') ×
      .modal-content
        kakao-map(:addr="addr")

</template>

<script src="//dapi.kakao.com/v2/maps/sdk.js?appkey=7266da0f504c71a0b97051295b15e1a0&libraries=services"></script>
<script>
import { mapGetters, mapActions } from 'vuex';
import South from './South';
import KakaoMap from './KakaoMap';
export default {
  components: {
    'south-svg': South,
    'kakao-map': KakaoMap,
  },
  data() {
    return {
      areaCategory: [],
      selectArea: 0,
      storeList: [],
      paging: [],
      page: '',
      pageNumber: [],
      addr: '',
      showModal: false,
      yScroll: 0,
    };
  },
  computed: {
    ...mapGetters(['userAccToken', 'lan', 'storePage']),
    isSigned() {
      return this.userAccToken === null ? false : true;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    },
  },
  methods: {
    ...mapActions(['savePage']),
    clickedCat(id) {
      this.page = 1;
      this.$refs.south.area = id;
      this.selectArea = id;
      this.getStoreList();
    },
    async getStoreList() {
      // NOTE: id = 0 -> 전체 조회
      this.page == '' ? (this.page = 1) : null;
      await this.$_axios('GET', 'board/store/list', {
        id: this.selectArea,
        page: this.page,
        nation: this.lan,
      }).then(res => {
        this.storeList = res.data.res[0];
        this.paging = res.data.res[1];
        this.pageNumber = new Array(this.paging[1] + 1 - this.paging[0])
          .fill(this.paging[0])
          .map((n, i) => n + i);
      });
    },
    getAreaCategory() {
      let param = {
        nation: this.lan,
      };
      this.$_axios('GET', 'board/store/area/category', param).then(res => {
        this.areaCategory = res.data.res;
      });
    },
    selectPage(num) {
      if (num == 'prev') {
        this.page = this.paging[0] - 1;
      } else if (num == 'next') {
        this.page = this.paging[1] + 1;
      } else {
        this.page = num;
      }
      this.savePage(['store', num]);
      this.getStoreList();
    },
    async clickedArea(area) {
      // NOTE: 지도 영역 클릭 이벤트
      this.page = 0;
      if (this.selectArea !== area) {
        this.selectArea = area;
        await this.getStoreList();
      }
    },
    openModal(index) {
      // NOTE: modal을 활성화
      // 현재 위치의 yScroll 값을 저장하여 scroll hidden class를 활성화했을 때 0이 되는 yScroll 값 때문에 style.top으로 현재 위치만큼 - 해줌
      if (this.lan == 'en') {
        this.addr = this.storeList[index].SHOP_ADDR_KR;
      } else if (this.lan == 'kr') {
        this.addr = this.storeList[index].SHOP_ADDR;
      }

      this.$emit('store-modal', true);
      this.showModal = true;
      this.yScroll = document.documentElement.scrollTop;
      const $_el = document.getElementById('html');

      if (this.isMobile) {
        $_el.classList.add('mobile-none-scroll');
      } else {
        $_el.classList.add('none-scroll');
        $_el.style.top = -this.yScroll + 'px';
      }
    },
    closeModal() {
      // NOTE: scroll hidden class를 제거, 제거하며 맨 위로 스크롤 이동되어 원래 위치하던 값으로 스크롤 이동시켜줌
      this.$emit('store-modal', false);
      this.showModal = false;
      const $_el = document.getElementById('html');
      if (this.isMobile) {
        $_el.classList.remove('mobile-none-scroll');
      } else {
        $_el.classList.remove('none-scroll');
      }
      window.scrollTo({
        top: this.yScroll,
        behavior: 'auto',
      });
    },
  },
  mounted() {
    if (this.storePage !== 0) {
      this.page = this.storePage;
    }
    this.savePage(['store', 0]);
    this.savePage(['news', 0]);
    this.getAreaCategory();
    this.getStoreList();
  },
};
</script>
<style scoped>
@import '../../assets/css/en/store_branch.css';
@import '../../assets/css/en/en_default.css';
#s51 .in .pg_wrap {
  margin-top: 50px;
}
.sub_right {
  padding: 0;
}
.bd_button {
  clear: both;
  text-align: right;
  margin-bottom: 10px;
  max-width: 1280px;
  margin: 0 auto;
}
.bd_button a {
  display: inline-block;
  padding: 10px 25px;
  border: 1px solid #ddd;
  line-height: 100%;
  margin-left: 5px;
  background: #fff;
}
.bd_button a.newb {
  background: #333;
  color: #fff;
}
.modal-content {
  margin: 0 auto;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 33%);
  font-family: Helvetica, Arial, sans-serif;
}
.modal-btn {
  text-align: right;
  background: transparent;
}
.modal-btn button {
  color: #ddd;
  font-style: normal;
  font-size: 28px;
  font-family: Arial, Baskerville, monospace;
  background: transparent;
  cursor: pointer;
  padding: 0;
}
.modal-btn button:hover {
  color: #fff;
}
.modal {
  display: flex;
  align-items: center;
}
.modal,
.modal_mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.modal_mask {
  opacity: 0.5;
  background-color: black;
}
.modal_card {
  margin: 0 auto;
  position: relative;
  z-index: 10;
  opacity: 1;
  width: 100%;
  max-width: 800px;
  max-height: 432px;
}
@media (max-width: 900px) {
  .modal_card {
    margin-left: 6px;
    margin-right: 6px;
  }
}
</style>
